
import React from 'react';
import PropTypes from 'prop-types';
import options from '../data/options.json';
import remove from 'lodash-es/remove';
import t from './utils/i18n.js';

const SearchLabels = (props) => {
    const removeFacet = (facet, value) => {
        if (facet === 'category' || facet === 'subCategory') {
            props.setCategory(value, facet, true)();
        } else {
            let facetState = props.filters.courses[facet];
            remove(facetState, (el) => el === value);
            props.filterCourses(facetState, facet);
        }
    };

    const filters = props.filters.courses;
    const filterLookup = {};

    for (const property in options.courses) {
        const propertyKey = (property === 'priceHalfyear') ? 'price' : property;
        filterLookup[propertyKey] = filterLookup[propertyKey] ? filterLookup[propertyKey] : {};
        for (const facet of options.courses[property]) {
            filterLookup[propertyKey][facet.key] = facet.name;
        }
    }

    return (filters.category.length || filters.subCategory.length || filters.christian || filters.courseType || filters.region || filters.price) ? (
        <div className="filter__labelswrapper">
            <div className="filter__labels">
                {filters.category.length ? (
                    <div className="filter__main-labels">
                        {filters.category.map((category) => (
                            <div className="filter__main-label-wrapper" key={category}>
                                <button className="filter__main-label" aria-label={"Fjern valg '" + category + "'"} onClick={() => removeFacet('category', category)}>{category}</button>
                            </div>
                        ))}
                    </div>
                    ) : ''
                }
                <div className="filter__sub-labels">
                    {filters.subCategory.length ? filters.subCategory.map((category) => (
                            <button className="filter__label" aria-label={"Fjern valg '" + category + "'"} key={category} onClick={() => removeFacet('subCategory', category)}>{category}</button>
                        ))
                        : ''
                    }
                    {filters.christian ? filters.christian.map((christian) => (
                            <button className="filter__label" aria-label={"Fjern valg '" + t(filterLookup.religion[christian], props.lang) + "'"} key={christian} onClick={() => removeFacet('christian', christian)}>{t(filterLookup.religion[christian], props.lang)}</button>
                        ))
                        : ''
                    }
                    {filters.courseType ? filters.courseType.map((type) => (
                            <button className="filter__label" aria-label={"Fjern valg '" + t(filterLookup.courseType[type], props.lang) + "'"} key={type} onClick={() => removeFacet('courseType', type)}>{t(filterLookup.courseType[type], props.lang)}</button>
                        ))
                        : ''
                    }
                    {filters.region ? filters.region.map((region) => (
                            <button className="filter__label" aria-label={"Fjern valg '" + t(filterLookup.region[region], props.lang) + "'"} key={region} onClick={() => removeFacet('region', region)}>{t(filterLookup.region[region], props.lang)}</button>
                        ))
                        : ''
                    }
                    {filters.price ? filters.price.map((price) => (
                            <button className="filter__label" aria-label={"Fjern valg '" + filterLookup.price[price] + "'"} key={price} onClick={() => removeFacet('price', price)}>{filterLookup.price[price]}</button>
                        ))
                        : ''
                    }
                </div>
            </div>
        </div>
    ) : '';
};

SearchLabels.propTypes = {
    filters: PropTypes.object,
    filterCourses: PropTypes.func,
    lang: PropTypes.string,
    setCategory: PropTypes.func
};

export default SearchLabels;
